import { combineReducers } from 'redux'

import { app } from './app'
import { sfBankAccounts } from './sf-bank-accounts'
import { sfWallets } from './sf-wallets'
import { userBankAccounts } from './user-bank-accounts'
import { userWallets } from './user-wallets'
import { introducer } from './introducer'
import { commissions } from './commissions'
import { auditLogs } from './audit-logs'
import { businessEntities } from './business-entities'
import { clientTypes } from './client-types'
import { assets } from './assets'
import { users } from './users'
import { generalSettings } from './general-settings'
import { transactions } from './transactions'
import { fireblocks } from './fireblocks'
import { crmRulesReducer as crmRules } from './crm-rules'
import { instruments } from './instruments'
import { fiat } from './fiat'

export const rootReducer = combineReducers({
  app,
  sfBankAccounts,
  sfWallets,
  userBankAccounts,
  userWallets,
  introducer,
  commissions,
  auditLogs,
  businessEntities,
  clientTypes,
  assets,
  users,
  generalSettings,
  transactions,
  fireblocks,
  crmRules,
  instruments,
  fiat,
})
